import { createTheme } from "@mui/material";

const primary = {
  main: "#216557",
  light: "#4d8378",
  dark: "#17463c",
  contrastText: "#fff",
};

const customColors = {
  backgroundColor: "#E9EEF0",
  infoTextColor: "#616161",
};

export const theme = createTheme({
  palette: {
    primary,
    custom: customColors,
  },
  typography: {
    fontFamily: "Roboto, sans-serif",
  },
  spacing: 8,
});
